import SymptomPointModel from '@common/Models/Symptom/SymptomPointModel';
import SymptomModel from '@common/Models/Symptom/SymptomModel';
import SymptomReportModel from '@common/Models/SymptomReport/SymptomReportModel';
import SymptomReportSymptomModel from '@common/Models/SymptomReport/SymptomReportSymptomModel';

export const convertSymptomToMarker = symptomReportSymptom => {
  if (!symptomReportSymptom) {
    return;
  }

  const marker = {
    point: {
      x: symptomReportSymptom.PosX,
      y: symptomReportSymptom.PosY,
      z: symptomReportSymptom.PosZ
    },
    Id: `${symptomReportSymptom.PosX}|${symptomReportSymptom.PosY}|${symptomReportSymptom.PosZ}`,
    SymptomId: symptomReportSymptom.SymptomId,
    saved: symptomReportSymptom._saved || false,
    Size: symptomReportSymptom.Size || 1,
    color: symptomReportSymptom._color,
    type: symptomReportSymptom.Type,
    opacity: symptomReportSymptom._opacity
  };

  if (!isNaN(symptomReportSymptom.Intensity)) {
    marker.Intensity = symptomReportSymptom.Intensity;
  }

  return marker;
};

export const convertSymptomPointToMarker = (symptomPoint, parent) => {
  const marker = {
    point: {
      x: symptomPoint.X,
      y: symptomPoint.Y,
      z: symptomPoint.Z
    },
    Id: `${symptomPoint.X}|${symptomPoint.Y}|${symptomPoint.Z}`,
    Size: symptomPoint.Size || 1,
    type: parent.Type,
    parent: parent || {}
  };

  return marker;
};

export const convertMarkerToSymptom = (marker, type) => {
  const symptom = new SymptomModel({});

  const symptomReportSymptom = new SymptomReportSymptomModel({
    PosX: marker.point.x,
    PosY: marker.point.y,
    PosZ: marker.point.z,
    Intensity: marker.Intensity,
    Size: marker.Size || 1,
    Symptom: symptom,
    SymptomId: symptom.Id
  });

  symptomReportSymptom._saved = marker.saved || false;

  return symptomReportSymptom;
};

export const convertMarkerToSymptomPoint = marker => {
  marker = marker.point || marker;

  return new SymptomPointModel({
    X: marker.x,
    Y: marker.y,
    Z: marker.z,
    Size: marker.Size || 1
  });
};

export const intensityTotal = (report, symptomType) => {
  const symptoms = report.Symptoms.filter(symptom => {
    return symptom.Type === symptomType;
  });

  let total = 0;

  for (let i = 0; i < symptoms.length; i++) {
    total += symptoms[i].Intensity;
  }
  return total;
};

export const intensityMax = (report, symptomType) => {
  const symptoms = report.Symptoms.filter(symptom => {
    return symptom.Type === symptomType;
  });
  if (!symptoms.length) {
    return 0;
  }
  return Math.max.apply(
    Math,
    symptoms.map(symptom => symptom.Intensity)
  );
};

export const getTrendIcon = trend => {
  if (trend === 1) {
    return 'mdi-arrow-top-right-thick';
  } else if (trend === -1) {
    return 'mdi-arrow-bottom-right-thick';
  } else {
    return 'mdi-arrow-right-thick';
  }
};

/**
 * Get trend by symptom type
 * @param {SymptomReportModel} report
 * @param {SymptomReportModel} previousReport
 * @param {String} symptomType
 * @returns
 */
export const getTrend = (report, previousReport, symptomType) => {
  if (!previousReport) {
    return null;
  }

  const currentTotal = intensityMax(report, symptomType);
  const previousTotal = intensityMax(previousReport, symptomType);

  if (currentTotal > previousTotal) {
    return 1;
  } else if (currentTotal < previousTotal) {
    return -1;
  } else {
    return 0;
  }
};
